export default "__VITE_ASSET__BzE5$TIU__"